import React from 'react'
import Route from './Route'
import { PATHS } from '@/consts/paths'

import UsersHomePage from '@/pages/Users/Home'
import CollectOrdersPage from '@/pages/Users/Collects/Orders'
import CollectPage from '@/pages/Users/Collects/Collect'
import IssuedCollectionsPage from '@/pages/Users/Collects/IssuedCollections'
import QueryNoShowPage from '@/pages/Users/Queries/NoShow'
import QueryInvoicesPage from '@/pages/Users/Queries/Invoices'
import RegistersPage from '@/pages/Users/Registers'

export function CarrierRoutes() {
  return (
    <>
      <Route path={PATHS.user.home} component={UsersHomePage} isPrivate exact />

      <Route
        path={PATHS.user.ordersForCollect}
        component={CollectOrdersPage}
        isPrivate
        exact
      />

      <Route
        path={PATHS.user.collect}
        component={CollectPage}
        isPrivate
        exact
      />

      <Route
        path={PATHS.user.issueds}
        component={IssuedCollectionsPage}
        isPrivate
        exact
      />

      <Route
        path={PATHS.user.queries.invoices}
        component={QueryInvoicesPage}
        isPrivate
        exact
      />

      <Route
        path={PATHS.user.queries.shipmentsNoShow}
        component={QueryNoShowPage}
        isPrivate
        exact
      />

      <Route
        path={PATHS.user.register}
        component={RegistersPage}
        isPrivate
        exact
      />
    </>
  )
}

export default CarrierRoutes
